import Image from '@repo/ui/src/components/Image';

interface Props {
  flag: string;
  name: string;
  current?: string;
}
export const CountryDetails = ({ flag, name }: Props) => (
  <>
    <div className="relative w-8/12 aspect-video mx-auto md:w-full">
      <Image src={flag} alt={`${name} flag`} layout="fill" />
    </div>
    <h5 className="text-white tra-text-web-heading-5 mt-3 text-center">{name}</h5>
  </>
);
